import HomeRoutes from 'src/features/home/routes/HomeRoutes';
import App from 'src/routes/App';

const protectedRoutes = [
    {
        element: <App />,
        children: [{ path: '/*', element: <HomeRoutes /> }],
    },
];

export { protectedRoutes };
